<div class="center-wrapper">
    <mat-spinner class="vertical-align" [diameter]="55" [strokeWidth]="7" value="determinate"></mat-spinner>
    <p class="vertical-align">
        {{ progressMessage }}
    </p>    
</div>